import config from '../config';

const getAllExhibitions = async () => {
  try {
    const response = await fetch(`${config.API_URL}/exhibitions`);
    const data = await response.json();
    
    if (Array.isArray(data)) {
      return data;
    } else if (data && data.data && Array.isArray(data.data)) {
      return data.data;
    } else {
      console.error('Invalid data format:', data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching all exhibitions:', error);
    return [];
  }
};

const getExhibitionsByCountry = async (countryId) => {
  const response = await fetch(`${config.API_URL}/exhibitions/country/${countryId}`);
  const data = await response.json();
  console.log('getExhibitionsByCountry response:', data);
  console.log('data.data exists:', !!data.data);
  console.log('data.data is array:', Array.isArray(data.data));
  
  // API response formatı: direkt array veya { data: [...], log: {...}, message: "..." }
  if (Array.isArray(data)) {
    console.log('Returning direct array');
    return data; // Direkt array geliyor
  } else if (data && data.data && Array.isArray(data.data)) {
    console.log('Returning data.data array:', data.data);
    return data.data; // Wrapped format
  } else {
    console.error('Invalid data format:', data);
    return [];
  }
};

const getExhibitionById = async (exhibitionId) => {
  console.log('Calling getExhibitionById with ID:', exhibitionId);
  console.log('API URL:', `${config.API_URL}/exhibitions/${exhibitionId}`);
  const response = await fetch(`${config.API_URL}/exhibitions/${exhibitionId}`);
  const data = await response.json();
  console.log('getExhibitionById response:', data);
  
  // API response formatı: direkt object veya { data: {...}, log: {...}, message: "..." }
  if (data && data.data) {
    return data.data; // Wrapped format
  } else if (data && typeof data === 'object' && data.id) {
    return data; // Direkt object
  } else {
    console.error('Invalid data format:', data);
    return null;
  }
};

const getExhibitionPhotos = async (exhibitionId) => {
  console.log('Calling getExhibitionPhotos with ID:', exhibitionId);
  console.log('API URL:', `${config.API_URL}/exhibitions/${exhibitionId}/photos`);
  const response = await fetch(`${config.API_URL}/exhibitions/${exhibitionId}/photos`);
  const data = await response.json();
  console.log('getExhibitionPhotos response:', data);
  
  // API response formatı: direkt array veya { data: [...], log: {...}, message: "..." }
  if (Array.isArray(data)) {
    return data; // Direkt array
  } else if (data && data.data && Array.isArray(data.data)) {
    return data.data; // Wrapped format
  } else {
    console.error('Invalid data format:', data);
    return [];
  }
};

export default {
  getAllExhibitions,
  getExhibitionsByCountry,
  getExhibitionById,
  getExhibitionPhotos
};